/**
 * Image Research Agent Configuration
 *
 * Static configuration for image research tools.
 * TODO: Move API key retrieval to a secure service.
 */
// ═══════════════════════════════════════════════════════════════════════════
// API KEYS (TEMPORARY - TO BE MOVED TO SECURE SERVICE)
// ═══════════════════════════════════════════════════════════════════════════
/**
 * Brandfetch API key for logo and brand color retrieval.
 *
 * !!! JUDE RIZZO - PLEASE MOVE THIS TO THE EC2 MICROSERVICE AS A PASS-THROUGH !!!
 * !!! LIKE YOU DID WITH THE VOYAGE API KEY. THIS SHOULD NOT BE IN CLIENT CODE !!!
 *
 * Get your API key at: https://brandfetch.com/developers
 */
export const BRANDFETCH_API_KEY = 'n0QS9pDnJ7ZTrgsTHytw6z4X9r3liZnwSxaW4R3C3bZi4k8EKpz-ZWwGpTAYRlH5CoxnkZRnVaUEBpsX6qbqFA';
//'+KwHFdHba9YX7w2vbDHvdQroR1BC0N/rKsNq141QAg8=';
/**
 * Brandfetch Customer ID for Logo API.
 *
 * !!! JUDE RIZZO - MOVE THIS TO EC2 MICROSERVICE TOO !!!
 *
 * The Logo API uses a customerId (not API key) in the c parameter.
 * Get your customer ID from: https://brandfetch.com/developers
 * Example: https://cdn.brandfetch.io/apple.com?c={customerId}
 */
export const BRANDFETCH_CUSTOMER_ID = '1idF7Q8hdu_qMOLoKRV';
//'1idjFSOCwQRLt7wJtJ7';
// ═══════════════════════════════════════════════════════════════════════════
// API ENDPOINTS
// ═══════════════════════════════════════════════════════════════════════════
export const BRANDFETCH_SEARCH_URL = "https://api.brandfetch.io/v2/search";
export const BRANDFETCH_BRAND_URL = "https://api.brandfetch.io/v2/brands";
export const BRANDFETCH_LOGO_URL = "https://cdn.brandfetch.io";
// Wikimedia Commons API
export const WIKIMEDIA_API_URL = "https://commons.wikimedia.org/w/api.php";
// User-Agent for Wikimedia API (required)
export const WIKIMEDIA_USER_AGENT = "CarouselOffice/1.0 (https://usecarousel.com; contact@usecarousel.com)";
